"use strict";

exports.__esModule = true;
/**
 * Seek to a percentage number
 *
 * @param {number} percentage Percentage of duration to seek to
 * @param {Controller} controller The backend controller
 * @param {number} duration Duration of the video
 */

var seekToPercentage = function seekToPercentage(percentage, controller, duration) {
  var seekTo = Math.min(duration * (percentage / 100), duration);
  controller.seekTo(Math.max(0, seekTo));
};

exports["default"] = seekToPercentage;